import { Component, inject, signal, ViewChild } from '@angular/core';
import { DialogModule } from "primeng/dialog";
import { Button } from "primeng/button";
import { SharedComponentsModule } from "src/app/shared/shared-components/shared-components.module";
import { ToastModule } from "primeng/toast";
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ComprehensiveCoverService } from '../../service/comprehensive-cover.service';
import { TableModule } from 'primeng/table';
import { MenuModule } from "primeng/menu";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-comprehensive-approvals',
  standalone: true,
  imports: [DialogModule, Button, SharedComponentsModule, ToastModule, TableModule, CommonModule, MenuModule, DropdownModule, FormsModule],
  templateUrl: './comprehensive-approvals.component.html',
  styleUrl: './comprehensive-approvals.component.scss',
  providers: [MessageService]
})
export class ComprehensiveApprovalsComponent {
  @ViewChild('statusDropdown') statusDropdown: any;


  visible: boolean = false;
  screenWidth: number = 1200;
  loadingMessage = '';
  router = inject(Router);
  messageService = inject(MessageService);
  comprehensiveService = inject(ComprehensiveCoverService);
  quotations = signal([]);

  selectedStatusOption: string = 'PAID';

  viewQuote(quoteId: string) {
    console.log('View quote with ID:', quoteId);
    this.router.navigate(['/home/comprehensive-approvals', quoteId]);
  }

  policyStatusOptions = [
    {
      label: 'Quote',
      value: 'QUOTE'
    },
    {
      label: 'Paid',
      value: 'PAID'
    },
    {
      label: 'Awaiting Payment',
      value: 'AWAITING_PAYMENT'
    },
    {
      label: 'Rejected Quote',
      value: 'REJECTED_QUOTE'
    },
    {
      label: 'Failed Payment',
      value: 'FAILED_PAYMENT'
    },
    {
      label: 'Cancelled Quote',
      value: 'CANCELLED'
    },
    {
      label: 'Loaded',
      value: 'LOADED'
    }
  ];

  defaultOptionsValue = this.policyStatusOptions.find(option => option.value === 'PAID')?.value || null;

  ngOnInit() {
    this.screenWidth = window.innerWidth;
    window.addEventListener('resize', this.onResize.bind(this));
    this.fetchComprehensiveQuotations();
  }

  ngAfterViewInit() {
    if (this.statusDropdown) {
      this.statusDropdown.writeValue(this.defaultOptionsValue);
    }
  }

  onStatusChanged(event: any) {
    this.fetchComprehensiveQuotations(event.value)
  }

  fetchComprehensiveQuotations(status: string = 'PAID') {
    this.visible = true;
    this.loadingMessage = "Fetching Comprehensive Cover Quotes"
    this.comprehensiveService.fetchComprehensiveQuotations(status).subscribe({
      next: (data) => {
        this.quotations.set(data);
        if (this.quotations().length === 0) {
          this.messageService.add({ severity: 'info', summary: 'No Quotes', detail: 'No comprehensive cover quotations found with status : ' + status });
        }

        this.visible = false;
      },
      error: (error) => {
        console.error('Error fetching quotations:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch quotations' });
        this.visible = false;
      }
    });
  }

  onResize(event: Event) {
    this.screenWidth = window.innerWidth;
  }
}
